module.exports = __webpack_public_path__ + "img/Group 448.bb896133.png";